import { SortDirection } from '@core-models/sort/sort-direction';

export abstract class SortOptionBase {
    public abstract readonly propertyName: string;
    public direction: SortDirection;

    constructor(direction: SortDirection) {
        this.direction = direction;
    }
}